import styled from 'styled-components';

export const WrapperModal = styled.div`
  .modal {
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  /* Modal Content/Box */
  .modalContent {
    border-radius: 7px;
    background-color: #fefefe;
    margin: 12% auto; /* 15% from the top and centered */
    border: 1px solid #888;
    /* max-width: 53%;  Could be more or less, depending on screen size */
    width: fit-content;
    position: relative;

    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }

  .btnModal {
    display: flex;
    width: 100%;
    justify-content: space-between;
    border-bottom: 1px solid #e7e7e7;
    padding: 16px;

    &__title {
      width: 90%;
      font-size: 22px;
      font-weight: 900;
      align-self: center;

      @media screen and (max-width: 500px) {
        font-size: 20px;
      }
    }

    &__btn {
      width: 10%;
      padding: 0px;

      > i {
        color: black;
        margin-top: -25px;
      }
    }
  }

  .imgContent {
    display: flex;
    padding: 16px;

    &__first {
      margin-right: 16px;
      > p {
        text-align: center;
        padding-bottom: 10px;
        font-weight: 900;
      }

      @media screen and (max-width: 600px) {
        margin: 0 auto;
      }
    }

    &__last {
      > p {
        text-align: center;
        padding-bottom: 10px;
        font-weight: 900;
      }

      @media screen and (max-width: 600px) {
        margin: 0 auto;
      }
    }

    @media screen and (max-width: 600px) {
      flex-direction: column;
    }
  }

  .btnFooter {
    display: flex;
    padding: 16px;
    justify-content: center;

    &__btn {
      width: 30%;
      @media screen and (max-width: 500px) {
        width: 100%;
      }
    }
  }
`;

export default WrapperModal;
